import {useQuery} from "../../common/hooks/useQuery";
import React, {useEffect} from "react";
import {finishChangeEmail} from "../../util/APIUtils";
import {DEFAULT_REDIRECT_URI} from "../../constants";
import {Trans} from "@lingui/macro";
import logo from "../../assets/img/logoVinet.svg";
import {toast} from "react-toastify";

export default function AcceptChangeEmail(){
  const query = useQuery();
  const key = query.get('key');

  const handleAccept = async () => {
    if (key){
      try {
        const rs = await finishChangeEmail(key)
        if (rs.ok === false){
          toast.error("Link xác nhận đã được dùng hoặc hết hạn")
        }
        console.log(rs)
      } catch (e) {
        console.log(e)
      }
    }
  }

  useEffect(() => {
    handleAccept()
  },[key])

  return (
    <div className="h-screen w-full flex relative flex-col justify-center items-center">
      <div className="w-40 absolute top-10 left-10">
        <a href={DEFAULT_REDIRECT_URI}>
          <img src={logo} className="w-full mx-auto" alt="Logo VINET" />
        </a>
      </div>
      <div className="text-4xl font-bold text-[#007DC5]">
        <Trans>Xác nhận thành công</Trans>
      </div>
      <div className="flex flex-col items-center mt-5">
        <Trans>
          Bạn đã xác nhận đổi email thành công
        </Trans>
          <a href={DEFAULT_REDIRECT_URI}>
            <button className="text-white px-3 py-2 bg-[#007DC5] rounded mt-10 transition duration-300 hover:bg-opacity-75 border-2 border-[#007DC5]">
              <Trans>Về trang chủ</Trans>
            </button>
          </a>
      </div>
    </div>
  )
}
